import ListSolutions from '../../components/Solutions/ListSolutions/ListSolutions';
import Divider from '../../components/Divider/Divider';
import { SectionsProps } from '../../types/types';
const Solutions = ({ openModal }: SectionsProps) => {
  return (
    <>
      <section className='solutions'>
        <Divider />
        <div className='solutions__container'>
          <div className='solutions__info'>
            <h2 className='solutions__title title color'>
              Your Aims –<span className='title'> Our Solutions</span>
            </h2>
            <p className='solutions__text subtitle'>
              Reach Billions, Get Quick Funds Access, and Make disbursements
            </p>
          </div>
          <ListSolutions className='list-solutions' openModal={openModal} />
        </div>
      </section>
    </>
  );
};
export default Solutions;
